import { render } from "./NotTreat.vue?vue&type=template&id=01f98138"
import script from "./NotTreat.vue?vue&type=script&lang=js"
export * from "./NotTreat.vue?vue&type=script&lang=js"

import "./NotTreat.vue?vue&type=style&index=0&id=01f98138&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__